import type { CorrectionItem } from '@app/reducers/orm/employee/employee.model';

export enum CorrectionType {
  REACTIVATION = 'Reactivation',
  CORRECTION = 'Correction',
  PAYOUT = 'Payout',
  TRANSFER = 'Transfer',
}

export interface PartialBalanceItem {
  label: string;
  value: string;
  sign?: '+' | '-';
  moreDetails?: string;
  correction?: CorrectionItem;
  correctionType?: CorrectionType;
}

export interface PartialBalance {
  balanceId: string;
  label: string;
  value: string;
  items: PartialBalanceItem[];
  itemsAreCorrections?: boolean;
}
